var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 54 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.47 37.06v-.01a3.942 3.942 0 00-1.98-3.46 4 4 0 10-.03 6.93l3.23 1.87a22.971 22.971 0 01-5.86 5.69A22.576 22.576 0 0129 51.91v-3.45a4 4 0 10-4 0v3.45a23 23 0 01-16.69-9.52l3.23-1.87a4.007 4.007 0 10-2.01-3.47v.01l-3.26 1.89a22.964 22.964 0 010-19.91l3.26 1.9a4 4 0 102.01-3.46l-3.23-1.87a22.993 22.993 0 015.79-5.64c1.1-.76 2.269-1.416 3.49-1.96A22.69 22.69 0 0125 6.09v3.45a4 4 0 104 0V6.09c2.531.213 5.009.849 7.33 1.88a23.029 23.029 0 019.36 7.64l-3.23 1.87a4.007 4.007 0 102.01 3.46l3.26-1.9a23.031 23.031 0 01.01 19.92z",
    fill: "#2980ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 30H1a1 1 0 010-2h52a1 1 0 010 2z",
    fill: "#3f5c6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 13a4 4 0 11-6-3.46V11a2 2 0 104 0V9.54A3.98 3.98 0 0131 13z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 1v10a2 2 0 11-4 0V1a1 1 0 011-1h2a1 1 0 011 1z",
    fill: "#67b9cc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#285680"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.59 8.01c-1.221.544-2.39 1.2-3.49 1.96l-2.48-4.45A1 1 0 0112 4.16l1.75-.98a1.012 1.012 0 011.36.39zM42.29 5.46l-2.46 4.45a23.331 23.331 0 00-3.5-1.94l2.46-4.45c.271-.48.876-.653 1.36-.39l1.75.97a1 1 0 01.39 1.36zM41.9 53.85l-1.75.97a1 1 0 01-1.36-.38l-2.46-4.41a22.528 22.528 0 003.5-1.95l2.46 4.41a1 1 0 01-.39 1.36zM17.6 49.99l-2.48 4.49a1.006 1.006 0 01-1.36.4l-1.75-.97a1.006 1.006 0 01-.4-1.36l2.5-4.51a22.429 22.429 0 003.49 1.95z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.98 22.96a3.993 3.993 0 01-7.45-2.02l1.26.73a2 2 0 102.01-3.45l-1.26-.74a4 4 0 015.44 5.48z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.52 20.95a1.985 1.985 0 01-2.73.72l-1.26-.73-3.26-1.9-4.12-2.4a1 1 0 01-.37-1.36l1.01-1.73a1 1 0 011.37-.36l4.15 2.42 3.23 1.87 1.26.74a1.985 1.985 0 01.72 2.73z",
    fill: "#67b9cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.47 20.94a4 4 0 11-2.01-3.46l-1.26.74a2 2 0 002.01 3.45z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.85 16.64l-4.12 2.4-3.26 1.9-1.26.73a2 2 0 01-2.01-3.45l1.26-.74 3.23-1.87 4.15-2.42a1 1 0 011.37.36l1.01 1.73a1 1 0 01-.37 1.36z",
    fill: "#67b9cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 45a3.98 3.98 0 01-2 3.46V47a2 2 0 10-4 0v1.46A4 4 0 1131 45z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 47v10a1 1 0 01-1 1h-2a1 1 0 01-1-1V47a2 2 0 114 0z",
    fill: "#67b9cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54 40.5a3.974 3.974 0 01-4 .02l1.26-.74a2 2 0 10-2.01-3.46l-1.26.73a3.942 3.942 0 011.98-3.46 4 4 0 114.03 6.91z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8 39.78l-1.26.74-3.23 1.87-4.15 2.42a1 1 0 01-1.37-.36l-1.01-1.73a1.01 1.01 0 01.37-1.37l4.12-2.4 3.26-1.89v-.01l1.26-.73a2 2 0 012.01 3.46z",
    fill: "#67b9cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.48 37.05a1.985 1.985 0 00.72 2.73l1.26.74a4.007 4.007 0 112.01-3.47l-1.26-.73a2 2 0 00-2.73.73z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.22 42.72l-1.01 1.73a1 1 0 01-1.37.36l-4.15-2.42-3.23-1.87-1.26-.74a2 2 0 012.01-3.46l1.26.73v.01l3.27 1.9 4.11 2.39c.477.279.642.889.37 1.37z",
    fill: "#67b9cc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinesIcon);
export default __webpack_public_path__ + "static/media/MinesIcon.18eb5574.svg";
export { ForwardRef as ReactComponent };